import React from "react";
import style from "styled-components";
import PropTypes from "prop-types";

const Text = style.h1`
   font-size:${({ theme }) => theme.fontSizes.medium};
   text-align:center;
   margin-top:4.0rem;
`;

export default function Title({ children }) {
    return <Text>{children}</Text>;
}

Title.propTypes = {
    children: PropTypes.string,
};
